import { useTranslation } from 'react-i18next'

import { CaretRightIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import { getAggregateSentimentLabel, getTopicColor } from '@/metrics/pages/ReasonMetricDetailPage/helpers'
import SentimentLabel from '@/metrics/pages/ReasonMetricDetailPage/SentimentLabel/SentimentLabel'

import * as Styles from './styles'

const TopicRow = ({ topic, onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const isOther = Boolean(topic.is_other)
  const color = getTopicColor({ rank: topic.rank, isOther }, theme)
  const sentimentLabel = getAggregateSentimentLabel(topic.aggregated_sentiment, theme)
  const positionLabel = isOther ? '' : topic.rank
  const nameLabel = isOther ? t('Otros') : topic.name

  const clickable = Boolean(onClick)

  const handleClick = () => {
    if (!onClick) return

    onClick(topic)
  }

  return (
    <Styles.Container onClick={handleClick} clickable={clickable}>
      <Styles.Position>
        <Text type="bodyMRegular">{positionLabel}</Text>
      </Styles.Position>

      <Styles.DotContainer>
        <Styles.Dot color={color} />
      </Styles.DotContainer>

      <Styles.Label>
        <Text type="bodyMMedium">{nameLabel}</Text>
      </Styles.Label>

      <Styles.Bar>
        <Styles.BarFill width={topic.percentage} color={color} />
        <Styles.BarPercentage>
          <Text type="bodyMMedium">
            <FormatNumber style="percent">{topic.percentage}</FormatNumber>
          </Text>
        </Styles.BarPercentage>
      </Styles.Bar>

      <Styles.Count>
        <Text type="bodyMMedium">
          <FormatNumber style="decimal">{topic.note_count}</FormatNumber>
        </Text>
      </Styles.Count>

      <Styles.SentimentContainer>
        {sentimentLabel && <SentimentLabel type={topic.aggregated_sentiment} label={t(sentimentLabel)} />}
      </Styles.SentimentContainer>

      {clickable && (
        <Styles.ChevronContainer>
          <CaretRightIcon size={16} />
        </Styles.ChevronContainer>
      )}
    </Styles.Container>
  )
}

export default TopicRow
